export
const name: string = "AccDepth";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform         vec2        u_canvas_size_recip;
    uniform         sampler2D   u_tex_opaque_depth;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        // if we have more views in one canvas, and the glViewport restrict the drawing to only a selected part of the canvas
        // the gl_FragCoord.xy contains coodinates in pixes relative to the canvas and not relative the viewport
        vec2 normalizedTextureCoord = gl_FragCoord.xy * u_canvas_size_recip;

        vec4 depth = texture2D(u_tex_opaque_depth, normalizedTextureCoord);
        float depth_opaque = vec4ToFloat(depth);

        // HACK!!! the assigning the gl_FragCoord.z value to z is needed for iPhone6 :-)
        float z = gl_FragCoord.z;
        if (z > depth_opaque) {
            // discard is performance hit so accumulate zero instead
            gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
        }
        else {
            // we are using 8bpc so we store the complexity to red channel (max. 255 layers)
            // blending is set to ADD
            gl_FragColor = vec4(1.0 / 255.0, 0.0, 0.0, 0.0);
        }

    }
`;
